import { signUpAPI } from "../api/SignupCalls";
import { call, put, all } from "redux-saga/effects";
import { signUpFailed, signUpSuccess } from "../actions/signupactions";
import { moveToValidatePage } from "../actions/routeactions";
import { passValidateEmail } from "../actions/validateactions";
import { reportError } from "../actions/erroractions";

export function* signUpSaga(action) {
  try {
    const result = yield call(signUpAPI, action);

    if (result.ok) {
      yield all([
        put(signUpSuccess()),
        put(moveToValidatePage()),
        put(passValidateEmail(action.email)),
      ]);
    } else {
      yield all([put(signUpFailed()), put(reportError(result.message))]);
    }
  } catch (ex) {
    yield all([put(signUpFailed()), put(reportError(ex))]);
  }
}
